import { Record } from "../../fable_modules/fable-library.3.7.20/Types.js";
import { option_type, bool_type, list_type, record_type, class_type, int32_type, string_type } from "../../fable_modules/fable-library.3.7.20/Reflection.js";
import { UTC$reflection } from "../../fable_modules/Svea.Dry.Fable.1.0.4/Time.fs.js";

export class EndingFeeDTO extends Record {
    constructor(Description, FeeNr, Amount) {
        super();
        this.Description = Description;
        this.FeeNr = (FeeNr | 0);
        this.Amount = Amount;
    }
}

export function EndingFeeDTO$reflection() {
    return record_type("Containers.UpdateContractType.Model.EndingFeeDTO", [], EndingFeeDTO, () => [["Description", string_type], ["FeeNr", int32_type], ["Amount", class_type("System.Decimal")]]);
}

export class StartingFeeDTO extends Record {
    constructor(Description, FeeTemplateNr, Amount) {
        super();
        this.Description = Description;
        this.FeeTemplateNr = (FeeTemplateNr | 0);
        this.Amount = Amount;
    }
}

export function StartingFeeDTO$reflection() {
    return record_type("Containers.UpdateContractType.Model.StartingFeeDTO", [], StartingFeeDTO, () => [["Description", string_type], ["FeeTemplateNr", int32_type], ["Amount", class_type("System.Decimal")]]);
}

export class ChangeContractTypeSuggestionDTO extends Record {
    constructor(EndingFees, StartingFees) {
        super();
        this.EndingFees = EndingFees;
        this.StartingFees = StartingFees;
    }
}

export function ChangeContractTypeSuggestionDTO$reflection() {
    return record_type("Containers.UpdateContractType.Model.ChangeContractTypeSuggestionDTO", [], ChangeContractTypeSuggestionDTO, () => [["EndingFees", list_type(EndingFeeDTO$reflection())], ["StartingFees", list_type(StartingFeeDTO$reflection())]]);
}

export class EndingFee extends Record {
    constructor(Description, FeeNr, Amount, IsSelected) {
        super();
        this.Description = Description;
        this.FeeNr = (FeeNr | 0);
        this.Amount = Amount;
        this.IsSelected = IsSelected;
    }
}

export function EndingFee$reflection() {
    return record_type("Containers.UpdateContractType.Model.EndingFee", [], EndingFee, () => [["Description", string_type], ["FeeNr", int32_type], ["Amount", class_type("System.Decimal")], ["IsSelected", bool_type]]);
}

export class StartingFee extends Record {
    constructor(Description, FeeTemplateNr, Amount, IsSelected) {
        super();
        this.Description = Description;
        this.FeeTemplateNr = (FeeTemplateNr | 0);
        this.Amount = Amount;
        this.IsSelected = IsSelected;
    }
}

export function StartingFee$reflection() {
    return record_type("Containers.UpdateContractType.Model.StartingFee", [], StartingFee, () => [["Description", string_type], ["FeeTemplateNr", int32_type], ["Amount", class_type("System.Decimal")], ["IsSelected", bool_type]]);
}

export class ChangeContractTypeSuggestion extends Record {
    constructor(EndingFees, StartingFees) {
        super();
        this.EndingFees = EndingFees;
        this.StartingFees = StartingFees;
    }
}

export function ChangeContractTypeSuggestion$reflection() {
    return record_type("Containers.UpdateContractType.Model.ChangeContractTypeSuggestion", [], ChangeContractTypeSuggestion, () => [["EndingFees", list_type(EndingFee$reflection())], ["StartingFees", list_type(StartingFee$reflection())]]);
}

export class ChangeContractTypeDTO extends Record {
    constructor(StartDate, EndingFeeNr, StartingFeeTemplateNr) {
        super();
        this.StartDate = StartDate;
        this.EndingFeeNr = EndingFeeNr;
        this.StartingFeeTemplateNr = StartingFeeTemplateNr;
    }
}

export function ChangeContractTypeDTO$reflection() {
    return record_type("Containers.UpdateContractType.Model.ChangeContractTypeDTO", [], ChangeContractTypeDTO, () => [["StartDate", UTC$reflection()], ["EndingFeeNr", option_type(int32_type)], ["StartingFeeTemplateNr", option_type(int32_type)]]);
}

